import { render } from "./NotificationElement.vue?vue&type=template&id=98006086&scoped=true"
import script from "./NotificationElement.vue?vue&type=script&lang=js"
export * from "./NotificationElement.vue?vue&type=script&lang=js"

import "./NotificationElement.vue?vue&type=style&index=0&id=98006086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98006086"]])

export default __exports__